import { apiResource } from '@/util/resources'

export default {
  state: {
    reconciliation: {},
    showReconciliationDialog: null,
    showReconciliationCompleteDialog: false
  },
  actions: {
    reconciliationStart ({ state }, payload) {
      return new Promise((resolve, reject) => {
        apiResource.post('api/reconciliation/start', payload).then((response) => {
          if (response.data !== null) {
            state.reconciliation.status = response.data
            resolve(response.data)
          } else {
            reject()
          }
        }, error => {
          reject(error)
        })
      })
    },
    reconciliationCancel ({ state }, payload) {
      return new Promise((resolve, reject) => {
        apiResource.post('api/reconciliation/cancel', payload).then((response) => {
          state.reconciliation.status = response.data
          resolve(response.data)
        }, error => {
          reject(error)
        })
      })
    },
    calculateReconciliationPaymentPlan ({ rootGetters }, payload) {
      return new Promise((resolve, reject) => {
        payload.lang = rootGetters.longLocale
        apiResource.post('api/reconciliation/calculate', payload).then((response) => {
          if (response.data !== null) {
            resolve(response.data)
          } else {
            reject()
          }
        }, error => {
          reject(error)
        })
      })
    },
    createReconciliationPaymentPlan ({ state }, payload) {
      return new Promise((resolve, reject) => {
        apiResource.post('api/reconciliation/create', payload).then((response) => {
          if (response.data !== null) {
            state.reconciliation.status = response.data
            resolve(response.data)
          } else {
            reject()
          }
        }, error => {
          reject(error)
        })
      })
    },
    signReconciliation ({ commit }, data) {
      commit('clearError')
      commit('setLoading', true)
      apiResource.post('api/reconciliation/url', data).then((response) => {
        commit('setLoading', false)
        window.location.href = response.data
      }).catch((errorResponse) => {
        commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
        commit('setLoading', false)
      })
    }
  },
  mutations: {
    setReconciliation (state, payload) {
      state.reconciliation = payload
    },
    setShowReconciliationDialog (state, payload) {
      state.showReconciliationDialog = payload
    },
    setShowReconciliationCompleteDialog (state, payload) {
      state.showReconciliationCompleteDialog = payload
    },
    logoutReconciliation (state) {
      state.reconciliation = {}
    }
  },
  getters: {
    reconciliation (state) {
      return state.reconciliation
    },
    showReconciliationCompleteDialog (state) {
      return state.showReconciliationCompleteDialog
    },
    showReconciliationDialog (state) {
      if (!state.reconciliation.hasOwnProperty('available') || !state.reconciliation.available) {
        return false
      }

      var subPoena = state.reconciliation.subpoenas[0]

      if (subPoena.status === null && state.showReconciliationDialog === null) {
        return false
      } else if (subPoena.status !== null && state.showReconciliationDialog === null) {
        return true
      } else {
        return state.showReconciliationDialog
      }
    }
  }
}
